/* assets/shop-collection.js
   Shop Heels / Shop Flats catalogue page (sections/shop-collection.liquid).
   Two small pieces of client-side behavior, both purely presentational —
   no navigation, no cart/variant logic:
   1) SHOW filter chips (All / Bases / Tops) — toggles card visibility by
      the data-bundle attribute each card carries (set server-side from the
      product's _badge_base_only / _badge_top_only tag).
   2) Color swatches on multi-colorway tops — swap the card's displayed
      image, matching the design source's per-card color preview.
*/
(function () {
  'use strict';

  document.querySelectorAll('[data-shopcol-root]').forEach(function (root) {
    var chips = root.querySelectorAll('[data-shopcol-chip]');
    var cards = root.querySelectorAll('[data-shopcol-card]');
    var emptyEl = root.querySelector('[data-shopcol-empty]');
    var grid = root.querySelector('[data-shopcol-grid]');

    function applyFilter(filter) {
      var visibleCount = 0;
      cards.forEach(function (card) {
        var match = filter === 'all' || card.getAttribute('data-bundle') === filter;
        card.hidden = !match;
        if (match) visibleCount += 1;
      });
      if (emptyEl) emptyEl.hidden = visibleCount > 0;
      if (grid) grid.hidden = visibleCount === 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        applyFilter(chip.getAttribute('data-filter'));
      });
    });

    cards.forEach(function (card) {
      var img = card.querySelector('[data-shopcol-img]');
      var swatches = card.querySelectorAll('[data-swatch]');
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          var newSrc = sw.getAttribute('data-img');
          if (img && newSrc) img.src = newSrc;
        });
      });
    });
  });
})();
